module.exports = __webpack_public_path__ + "static/vmware_25.b00671c3.jpg";